import { cacheExchange, fetchExchange } from '@urql/core'
import { devtoolsExchange } from '@urql/devtools'
import { requestPolicyExchange } from '@urql/exchange-request-policy'
import introspection from 'gen/introspection.json'
import { buildAuthExchange } from './auth'
import { subscription } from './subscription'
import { bugsnagExchange } from './bugsnag'
import { operationNameExchange } from './operationName'
import { additionalTypenamesExchange } from './additionalTypenames'

export const exchanges =
  process.env.NODE_ENV === 'development'
    ? [
        devtoolsExchange,
        requestPolicyExchange({}),
        cacheExchange,
        additionalTypenamesExchange({ introspection }),
        operationNameExchange(),
        buildAuthExchange(),
        fetchExchange,
        subscription,
      ]
    : [
        requestPolicyExchange({}),
        cacheExchange,
        bugsnagExchange,
        additionalTypenamesExchange({ introspection }),
        operationNameExchange(),
        buildAuthExchange(),
        fetchExchange,
        subscription,
      ]
